/**
 * Global Organization JSON-LD — une seule injection hors pages prerender / SEO programmatique.
 */

import { useMemo } from 'react';
import { useStructuredData } from '@/hooks/useStructuredData';
import { buildGlobalGraph } from '@/lib/seo/jsonld-pipeline';
import {
  hasTier1PrerenderInDocument,
  isProgrammaticSeoPathname,
} from '@/lib/seo/structured-data-prerender-guard';

const SEOOrganizationSchema = () => {
  const graph = useMemo(() => buildGlobalGraph(), []);

  const skip =
    typeof window !== 'undefined' &&
    (hasTier1PrerenderInDocument() || isProgrammaticSeoPathname(window.location.pathname));

  useStructuredData(skip ? [] : graph);

  return null;
};

export default SEOOrganizationSchema;
